import { FunctionComponent, useEffect, useState } from "react";
import CatalogArea from "../../components/CatalogArea";
import FeaturedCatalog from "../../components/FeaturedCatalog";
import Footer from "../../components/Footer";
import HomeVideo from "../../components/HomeVideo";
import HomeCatalogContainer from "../../components/HomeCatalogContainer";
import { useAsync } from "../../utils/hooks/useAsync";
import { carouselServices } from "../../services/carousels";
import Loading from "../../components/common/Loading";

const Home: FunctionComponent = ({}) => {
  const { isSuccess, isLoading, run } = useAsync();
  const [carousels, setCarousels] = useState<CarouselExtended[]>();
  const [featuredProducts, setFeaturedProducts] = useState<CarouselExtended>();

  useEffect(() => {
    try {
      run(
        carouselServices
          .getCarousels({})
          .then((data: { data: CarouselExtended[] }) => {
            setCarousels(data.data.filter((el) => el.name != "HIGHLIGHTED"));
            setFeaturedProducts(
              data.data.find((el) => el.name == "HIGHLIGHTED")
            );
          })
      );
    } catch (e) {
      console.log(
        "[DEBUG/HomePage] - Error building carousel infromation - ",
        e
      );
    }
  }, []);

  return (
    <>
      <section className="home_container" id="skip-to-content">
        <section className="home_catalog">
          <section className="home_featured">
            {featuredProducts && isSuccess && (
              <>
                <div className="home_featured_title">
                  <h3>Destacados</h3>
                </div>
                <FeaturedCatalog products={featuredProducts} />
              </>
            )}
          </section>
          {carousels && isSuccess && (
            <HomeCatalogContainer sections={carousels} />
          )}
          {isLoading && <Loading />}
        </section>
        <HomeVideo />
        <CatalogArea />
      </section>
      <Footer />
    </>
  );
};

export default Home;
